module.exports = __webpack_public_path__ + "static/media/3950.25301eee.jpg";